import {
    AmericanExpressIcon,
    ApplePayIcon,
    DiscoverIcon,
    GoogleWalletIcon,
    MastercardIcon,
    VisaIcon,
} from '@/ui/common/Icons/PaymentCards';
import { ReactNode } from 'react';

type TPaymentIconsProps = {
    isStripe?: boolean;
};

const Icon = ({ children }: { children: ReactNode }) => {
    return (
        <div className="pointer-events-none flex h-[45px] w-[74px] flex-shrink-0 items-center justify-center rounded border border-gray-3 bg-white bg-contain bg-no-repeat dark:border-dark-1 dark:bg-blue-1">
            {children}
        </div>
    );
};

export const PaymentIcons = ({ isStripe }: TPaymentIconsProps) => {
    return (
        <div className="flex w-full flex-col gap-3 sm:gap-5">
            <span className="tx-large-regular text-gray-2 dark:text-gray-3">
                Flexible Payment Options
            </span>
            <div className="flex w-full flex-wrap items-center gap-3 sm:gap-5">
                <Icon>
                    <MastercardIcon />
                </Icon>
                <Icon>
                    <VisaIcon />
                </Icon>
                <Icon>
                    <AmericanExpressIcon />
                </Icon>
                <Icon>
                    <DiscoverIcon />
                </Icon>
                {!!isStripe && (
                    <>
                        <Icon>
                            <GoogleWalletIcon />
                        </Icon>
                        <Icon>
                            <ApplePayIcon />
                        </Icon>
                    </>
                )}
            </div>
        </div>
    );
};
